import Link from 'next/link'
import { PlusCircleIcon } from '@heroicons/react/outline'
import useQueryContext from '@hooks/useQueryContext'
import useRealm from '@hooks/useRealm'
import { useMemo } from 'react'
import Tooltip from '@components/Tooltip'
import useWalletOnePointOh from '@hooks/useWalletOnePointOh'
import { useRealmQuery } from '@hooks/queries/realm'
import { useRealmGovernancesQuery } from '@hooks/queries/governance'
import { useLegacyVoterWeight } from '@hooks/queries/governancePower'

const NewProposalBtn = () => {
  const { fmtUrlWithCluster } = useQueryContext()

  const wallet = useWalletOnePointOh()
  const connected = !!wallet?.connected

  const realm = useRealmQuery().data?.result
  const { result: ownVoterWeight } = useLegacyVoterWeight()
  const {
    symbol,
    toManyCommunityOutstandingProposalsForUser,
    toManyCouncilOutstandingProposalsForUse,
  } = useRealm()

  const governancesQuery = useRealmGovernancesQuery()
  const governanceItems = useMemo(() => governancesQuery.data ?? [], [
    governancesQuery.data,
  ])
  const canCreateProposal =
    realm &&
    governanceItems.some((g) =>
      ownVoterWeight?.canCreateProposalUsingCouncilTokens(g.account.config)
    ) &&
    !toManyCommunityOutstandingProposalsForUser &&
    !toManyCouncilOutstandingProposalsForUse

  const tooltipContent = !connected
    ? // ? 'Connect your wallet to create new proposal'
      'Connect your wallet to create a new proposal or visit the MIP website'
    : governanceItems.length === 0
    ? 'There is no governance configuration to create a new proposal'
    : !governanceItems.some((g) =>
        ownVoterWeight?.canCreateProposalUsingCouncilTokens(g.account.config)
      )
    ? 'See proposal submission site.'
    : toManyCommunityOutstandingProposalsForUser
    ? 'Too many community outstanding proposals. You need to finalize them before creating a new one.'
    : toManyCouncilOutstandingProposalsForUse
    ? 'Too many council outstanding proposals. You need to finalize them before creating a new one.'
    : ''

  return (
    <>
      <Tooltip content={tooltipContent}>
        <div>
          <Link
            href={
              canCreateProposal
                ? fmtUrlWithCluster(`/dao/${symbol}/proposal/new`)
                : 'https://mip.metaplex.com'
            }
          >
            <a
              className={`flex items-center cursor-pointer text-primary-light hover:text-primary-dark text-sm`}
              target={canCreateProposal ? '' : '_blank'}
            >
              <PlusCircleIcon className="flex-shrink-0 h-5 mr-1 w-5" />
              New Proposal
            </a>
          </Link>
        </div>
      </Tooltip>
    </>
  )
}

export default NewProposalBtn
